import React, { useMemo } from "react";
import CustomCard from "../Card";
import { EChartsOption } from "echarts";
import ReactEchart from "../../../../molecules/ReactEchart";

const AverageTime: React.FC = React.memo(() => {
  const options: EChartsOption = useMemo(() => {
    const isMobile = window.innerWidth < 600;

    return {
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
        formatter: (params: any) => {
          const { value } = params[0];
          return `${value}K`;
        },
      },
      grid: {
        left: "5%",
        right: "5%",
        bottom: "15%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: [
          "Air Conditioning",
          "Carpentry",
          "Electrical",
          "Masonry",
          "Painting",
          "Plumbing",
          "TV & Commu.",
          "Flooring",
        ],
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: {
          fontSize: isMobile ? 10 : 12,
          color: "#1F5782",
          rotate: isMobile ? 25 : 0,
          interval: "auto",
          width: isMobile ? 50 : "auto",
          overflow: "break",
        },
      },
      yAxis: {
        type: "value",
        splitLine: {
          show: true,
          lineStyle: { color: "#E0E0E0", type: "solid" },
        },
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: { show: false },
      },
      series: [
        {
          type: "bar",
          data: [2.5, 3.0, 5.2, 4.5, 3.8, 4.2, 2.9, 3.7],
          barWidth: "35%",
          itemStyle: {
            borderRadius: [8, 8, 0, 0],
            color: ({ dataIndex }) => (dataIndex === 3 ? "#0E3D5D" : "#1F5782"),
          },
          label: {
            show: false,
            position: "top",
            fontSize: 14,
            fontWeight: "bold",
            formatter: ({ value }) => `${value}K`,
            color: "#1F5782",
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 14,
              fontWeight: "bold",
              formatter: ({ value }) => `${value}K`,
              color: "#1F5782",
            },
          },
        },
      ],
    };
  }, []);

  return (
    <CustomCard heading="AVERAGE TIME" subHeading="TO CLOSE (HRS)/ CATEGORY">
      <ReactEchart
        options={options}
        style={{ height: "400px", width: "100%" }}
      />
    </CustomCard>
  );
});

export default AverageTime;
